export class AfterPurchaseProcessStatus {
  static completed(): AfterPurchaseProcessStatus {
    return new AfterPurchaseProcessStatus('completed')
  }

  static failed(): AfterPurchaseProcessStatus {
    return new AfterPurchaseProcessStatus('failed')
  }

  static redirected(): AfterPurchaseProcessStatus {
    return new AfterPurchaseProcessStatus('redirected')
  }

  private constructor(
    private status: 'completed' | 'failed' | 'redirected'
  ) {
  }

  fold(onSuspend: () => void, onComplete: () => void) {
    if (this.status === 'completed') {
      onComplete()
    } else {
      onSuspend()
    }
  }
}
